import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'getContactInitials' })
export class GetContactInitialsPipe implements PipeTransform {
  transform(contactName: string): string {
    const nameParts = contactName.split(' ');
    let title = '';
    nameParts.forEach((name, index) => {
      if (index < 2) {
        title = title + name[0];
      }
    });
    return title;
  }
}
